const hotels = {
  accommodation: "宿泊施設", // translated
  hotel: "ホテル", // translated
  hotels: "ホテル", // translated
  back: "戻る", // translated
  rooms: "部屋", // translated
  viewPictures: "写真を見る", // translated
  showMore: "もっと見る", // translated
  bookingInformation: "予約情報", // translated
  cancellationPolicy: "取り消し規約", // translated
  from: "から", // translated
  to: "に", // translated
  cancellationIs: "キャンセルは", // translated
  free: "無料", // translated
  chargeableWithFeeOf: "の料金で請求可能", // translated
  prebook: "事前予約", // translated
  guests: "ゲスト", // translated
  payment: "支払い", // translated
  byClicking: "クリックして", // translated
  next: "次", // translated
  youAreAgreeingToOur: "あなたは私たちのことに同意します", // translated
  termsAndConditions: "利用規約", // translated
  previous: "前の", // translated
  cancel: "キャンセル", // translated
  mealPlan: "食事プラン", // translated
  roomType: "部屋タイプ", // translated
  description: "説明", // translated
  readLess: "もっと読む", // translated
  readMore: "続きを読む", // translated
  facilities: "設備", // translated
  viewLess: "表示を減らす", // translated
  viewMore: "もっと見る", // translated
  less: "少ない", // translated
  more: "もっと", // translated
  notAvailable_short: "該当なし", // translated
  backToHotelList: "ホテル一覧に戻る", // translated
  viewOnMap: "地図で見る", // translated
  sleeps: "眠る", // translated
  adults: "大人", // translated
  yearsOld: "歳", // translated
  type: "タイプ", // translated
  bedding: "寝具", // translated
  selectRoom: "部屋を選択してください", // translated
  selectRooms: "部屋を選択してください", // translated
  city: "市", // translated
  checkIn: "チェックイン", // translated
  checkOut: "チェックアウト", // translated
  date: "日付", // translated
  dates: "日付", // translated
  persons: "人", // translated
  stillOnTrialQuestionToUpgrade: "おっとっと！まだお試しメンバーシップ中のようです。予約するには会員として承認されている必要があります。今すぐアップグレードしますか?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "おっとっと！まだ購読されていないようです。予約するには会員として承認されている必要があります。今すぐアップグレードしますか?", // translated
  completeProfile: "まずユーザープロフィールを完成させてください", // translated
  upgrade: "アップグレード", // translated
  close: "近い", // translated
  viewDetails: "詳細を見る", // translated
  name: "名前", // translated
  rating: "評価", // translated
  budget: "予算", // translated
  orderBy: "注文方法", // translated
  priceLowestFirst: "価格（安い順）", // translated
  priceHighestFirst: "価格（高い順）", // translated
  ratingLowestFirst: "評価（低い順）", // translated
  ratingHighestFirst: "評価（高い順）", // translated
  starRatingAndPrice: "星の評価と価格", // translated
  biggestSavingsFirst: "まずは最大の節約", // translated
  select: "選択する", // translated
  reset: "リセット", // translated
  apply: "適用する", // translated
  filterBy: "フィルター条件", // translated
  myProfile: "私のプロフィール", // translated
  login: "ログイン", // translated
  roomOnly: "部屋のみ", // translated
  bedAndBreakfast: "ベッド＆ブレックファスト", // translated
  halfBoard: "2食付き", // translated
  fullBoard: "三食付き", // translated
  allInclusive: "オールインクルーシブ", // translated
  filter: "フィルター", // translated
  mapView: "マップビュー", // translated
  results: "結果", // translated
  listView: "リストビュー", // translated
  newSearch: "新しい検索", // translated
  editSearch: "検索の編集", // translated
  all: "全て", // translated
  multiple: "複数", // translated
  editProfile: "プロファイル編集", // translated
  backToHotelsList: "ホテル一覧に戻る", // translated
  roomName: "部屋の名前", // translated
  mealType: "食事の種類", // translated
  freeCancellation: "無料キャンセル", // translated
  yes: "はい", // translated
  no: "いいえ", // translated
  filters: "フィルター", // translated
  cancellationNonRefundable: "キャンセルは返金不可です", // translated
  hotelRating: "ホテルの評価", // translated
  any: "どれでも", // translated
  off: "オフ", // translated
  performNewSearch: "新しい検索を実行する", // translated
};


export default hotels;
